import React from "react";
import "../../../components/jds/jds.css";
import "../Vinculacao/vinculacao.css";
import {
  SCOPE_FAMILIES,
  toggleScopes,
  unknownScopes,
} from "../utils/scopeCatalog";

// Os produtos que um cliente da calculator-api pode usar, agrupados por família.
// Usado na criação e na edição; quem chama guarda a lista e decide quando salvar.
// Precisa ser renderizado dentro de .jds-scope.
//
// Os escopos que a tela não conhece aparecem crus, marcados e travados: o PATCH
// substitui a lista inteira, então desmarcá-los aqui os apagaria no cliente.
export default function ScopeSelector({ selectedScopes, onChange }) {
  const preservedScopes = unknownScopes(selectedScopes);

  const setChecked = (scopes, checked) =>
    onChange(toggleScopes(selectedScopes, scopes, checked));

  return (
    <>
      {selectedScopes.length === 0 && (
        <div className="vinculacao-alert vinculacao-alert--warning" role="alert">
          Nenhum produto marcado: o cliente não vai conseguir acessar nenhum
          produto.
        </div>
      )}

      {SCOPE_FAMILIES.map(family => {
        const familyScopes = family.scopes.map(({ scope }) => scope);
        const allChecked = familyScopes.every(scope =>
          selectedScopes.includes(scope),
        );
        const legendId = `scope-family-legend-${family.key}`;

        // o `legend` fica num flex ao lado do "Marcar todos", então deixa de
        // ser filho direto do `fieldset`: o nome do grupo vem do aria-labelledby
        return (
          <fieldset
            key={family.key}
            className="vinculacao-family"
            aria-labelledby={legendId}
          >
            <div className="vinculacao-family__header">
              <legend
                id={legendId}
                className="jds-title-xs vinculacao-family__legend"
              >
                {family.label}
              </legend>
              {familyScopes.length > 1 && (
                <label
                  className="vinculacao-check"
                  htmlFor={`scope-family-${family.key}`}
                >
                  <input
                    type="checkbox"
                    id={`scope-family-${family.key}`}
                    checked={allChecked}
                    onChange={event =>
                      setChecked(familyScopes, event.target.checked)
                    }
                  />
                  <span>Marcar todos</span>
                </label>
              )}
            </div>

            <div className="vinculacao-family__scopes">
              {family.scopes.map(({ scope, label }) => (
                <label
                  className="vinculacao-check"
                  htmlFor={`scope-${scope}`}
                  key={scope}
                >
                  <input
                    type="checkbox"
                    id={`scope-${scope}`}
                    checked={selectedScopes.includes(scope)}
                    onChange={event => setChecked([scope], event.target.checked)}
                  />
                  <span>{label}</span>
                </label>
              ))}
            </div>
          </fieldset>
        );
      })}

      {preservedScopes.length > 0 && (
        <fieldset className="vinculacao-family">
          <legend className="jds-title-xs vinculacao-family__legend">
            Outros
          </legend>
          <p className="text-muted vinculacao-family__hint">
            Produtos que esta tela ainda não conhece. São mantidos ao salvar.
          </p>
          {preservedScopes.map(scope => (
            <label
              className="vinculacao-check"
              htmlFor={`scope-${scope}`}
              key={scope}
            >
              <input
                type="checkbox"
                id={`scope-${scope}`}
                checked
                readOnly
                disabled
              />
              <span>
                <code>{scope}</code>
              </span>
            </label>
          ))}
        </fieldset>
      )}
    </>
  );
}
